export default "__VITE_ASSET__CcMwW__o__"